import { createStore } from 'vuex'
import modules from './modules'
import { http } from '@/system/http.js';
import Brands from '@/core/Brands.js';
import moment from "moment";
import PatientTravel from 'PatientTravel/store';

const hasDefaultVuexRootState = window.__defaultVuexState && window.__defaultVuexState.root !== undefined && typeof window.__defaultVuexState.root === 'object';
const defaultRootState = Object.assign({}, hasDefaultVuexRootState ? window.__defaultVuexState.root : {});

const store = createStore({
    modules: {
        ...modules,
        patientTravel: { namespaced: true, ...PatientTravel},
    },

    state: Object.assign({
        base_subscription_price_monthly_in_cents: 0,
        base_subscription_price_yearly_in_cents: 0,
        subscription_price_monthly_in_cents: 0,
        subscription_price_yearly_in_cents: 0,
        custom_monthly_price_months: null,
        custom_yearly_price_months: null,
        interval_price_in_cents: 0,
        free_months: 0,
        brand: Brands.EasyPractice,
        is_aspit_user: false,
        is_migrated_aspit_user: false,
        support_email: trans('global.system_email'),
        // This property is not populated on every page.
        // See `Root::loadAdditionalAppsWithoutPaywall` for more info on when this property is set.
        additional_apps_without_paywall: [],
        helsenett_is_radiology_supported: false,

        // this will load the default vuex state from the backend. Check VuexService class.
        // it will override the values set above with the default values coming from the backend.
    }, defaultRootState),

    mutations: {},

    actions: {
        reloadState(context) {
            if (context.loading) return;

            context.loading = true;

            http.get('/app/fe-state/root')
                .then(({ data }) => {
                    context.state = Object.assign(context.state, data);
                    context.loading = false;
                })
                .catch(() => {
                    context.loading = false;
                });
        },
        reloadStateAuth(context) {
            http.get('/app/fe-state/auth')
                .then(({ data }) => {
                    context.state.auth = Object.assign(context.state.auth, data);
                })
                .catch(() => {});
        },
    },

    getters: {
        isAspitBrand: state => [Brands.Physica, Brands.Psykbase].includes(state.brand),
        isTerapeutBookingBrand: state => state.brand === Brands.TerapeutBooking,
        isNordhealthBrand: state => [Brands.Physica, Brands.Psykbase, Brands.TerapeutBooking].includes(state.brand),
        hasFreeBookingSmsReminders: state => state.has_free_booking_sms_reminders,
    }
})

export default store
